<ngb-alert [type]="type" [dismissible]="false">
  <ng-content select="[message-content]"></ng-content>
</ngb-alert>